namespace RioERP.Orders {
    export interface OrderProductBillingItemsForm {
        OrderId: Serenity.LookupEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxCategoryId: Serenity.LookupEditor;
        ProductBillingItemId: Serenity.LookupEditor;
        InvoiceCompanyId: Serenity.LookupEditor;
        OrderProductBillingItemsTax: OrderProductBillingItemsTaxEditor;
    }

    export class OrderProductBillingItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderProductBillingItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductBillingItemsForm.init)  {
                OrderProductBillingItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = OrderProductBillingItemsTaxEditor;

                Q.initFormType(OrderProductBillingItemsForm, [
                    'OrderId', w0,
                    'GrossAmount', w1,
                    'DiscountAmount', w1,
                    'NetAmount', w1,
                    'TaxableAmount', w1,
                    'TaxCategoryId', w0,
                    'ProductBillingItemId', w0,
                    'InvoiceCompanyId', w0,
                    'OrderProductBillingItemsTax', w2
                ]);
            }
        }
    }
}
